import { StorageDriver } from '../../providers';

export const AUTH_DATA_KEY = 'OPO_TEST_AUTH_DATA';


const defaultStorage: StorageDriver & { data: string | null } = {
  data: '{}',
  getItem(key: string) {
    return Promise.resolve(this.data);
  },
  setItem(key: string, value: any) {
    this.data = value;
    return Promise.resolve();
  },
  removeItem(key: string) {
    this.data = '{}';
    return Promise.resolve();
  }
};

type AuthStorageObjectType = {
  storage: StorageDriver;
};

const fallbackGlobalObject: AuthStorageObjectType = {
  storage: defaultStorage,
};

const init = (newStorage: StorageDriver) => {
  fallbackGlobalObject.storage = newStorage;
};

interface AuthDataType {
  token: string;
  refresh_token: string;
  username?: string;
}

const get: () => Promise<AuthDataType> = () => {
  return fallbackGlobalObject.storage
    .getItem(AUTH_DATA_KEY)
    .then((data: string) => JSON.parse(data))
    .then((data: AuthDataType & { user?: string }) => {
      if (data && data.user && !data.username) {
        return { ...data, username: data.user };
      } else {
        return data;
      }
    });
};

const set = (data: AuthDataType, persist?: boolean) => {
  return fallbackGlobalObject.storage.setItem(AUTH_DATA_KEY, JSON.stringify(data));
};

const remove = () => fallbackGlobalObject.storage.removeItem(AUTH_DATA_KEY);

export default { get, set, remove, init };
